import first from 'lodash/first';

export const extractCurrentSortOption = (sort) => {
  const firstItem = first(sort);
  return firstItem && firstItem.property && firstItem.direction ? `${firstItem.property},${firstItem.direction}` : undefined;
};

export const RT_ANON_USER_POPUP_FLAG_ID = 'RTAnonUserPopup';
export const RT_COLLAPSE_PARAMS_FLAG_ID = 'RTCollapseParams';

export const getProjectById = (id, list = []) => first(list.filter((p) => p.id === id));
